import { API } from "api";

export const getCompanyStatusListAPI = () => {
    return API.get("api/companyvalidation/getall?page=0&size=0&sortColumnName=PkCompany")
                .then((res) => res);
};
